import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { SettingsState } from '../../store/settings/settings.state';
import { Observable, Subject } from 'rxjs';
import { LanguageType } from '../../samwebDescription/samweb/settings/language-types';
import { takeUntil } from 'rxjs/operators';

@Injectable({
   providedIn: 'root',
})
export class TranslationConfigurationService implements OnDestroy {
   private terminated$ = new Subject();

   @Select(SettingsState.getCurrentLanguage)
   public currentLanguage$: Observable<LanguageType>;

   @Select(SettingsState.getFallbackLanguage)
   public fallbackLanguage$: Observable<LanguageType>;

   constructor(private translate: TranslateService) {}

   public initialize() {
      this.fallbackLanguage$.pipe(takeUntil(this.terminated$)).subscribe((x) => {
         this.translate.setDefaultLang(x.angularTranslationKey);
      });
      this.currentLanguage$.pipe(takeUntil(this.terminated$)).subscribe((x) => {
         this.translate.use(x.angularTranslationKey);
      });
   }

   ngOnDestroy(): void {
      this.terminated$.next();
      this.terminated$.complete();
   }
}
